import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import type { RootState } from 'reducers/types';
import { getTheme } from 'selectors/ui/ui';
import { embeddedStyler } from 'utils/embeddedStyler/embeddedStyler';

type Props = ConnectedProps<typeof connector>;

export const EmbeddedStyleComponent = ({ theme }: Props) => {
  const { brandColor } = theme;

  const button = embeddedStyler('button', brandColor);
  const inputFocus = embeddedStyler('inputFocus', brandColor);
  const textAreaFocus = embeddedStyler('textAreaFocus', brandColor);
  const autocompleteFocus = embeddedStyler('autocompleteFocus', brandColor);
  const checkbox = embeddedStyler('checkbox', brandColor);
  const modal = embeddedStyler('modal', brandColor);
  const site = embeddedStyler('site', brandColor);
  const spinner = embeddedStyler('spinner', brandColor);

  return (
    <style>
      {button}
      {inputFocus}
      {textAreaFocus}
      {autocompleteFocus}
      {checkbox}
      {modal}
      {site}
      {spinner}
    </style>
  );
};

const mapStateToProps = (state: RootState) => ({
  theme: getTheme(state),
});

const connector = connect(mapStateToProps);
const EmbeddedStyle = connector(EmbeddedStyleComponent);

export { EmbeddedStyle };
